import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { CardBody, Card } from '../../../components/card/card';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { GetLookupManagList } from '../../../store/NTX/Lookup/lookupsSlice';
import { useTranslation } from 'react-i18next';
import ModalComponent from '../../../components/Modal/ModalComponent';
import AddLookup from './AddLookup';
import UpdateLookup from './UpdateLookup';
import useLookupModule from '../../../hooks/Lookups/use-Lookup-Module';
import Breadcrumb from '../../../components/Shared/Breadcrumb';
import { usePermissions } from '../../../Helper/Permisstions/usePermissions';
import Loading from '../../../components/Shared/Loader/Loading';
import NtxTable from '../../../components/DataTable/NtxTable';

const Lookup = () => {
  const { HasPermission } = usePermissions();

  const [search, setSearch] = useState('');
  const [dataPerPage] = useState(10);
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [categoryValue, setCategoryValue] = useState<string | null>();
  const [categoryName, setCategoryName] = useState<string>();
  const [moduleId, setModuleId] = useState<string>();
  const [ID, setID] = useState<string>(); //      استعماله في مكون التعديل
  const [optionSelect, setOptionSelect] = useState<any>();
  const { Module } = useLookupModule();
  const { LookupData, loading, error } = useAppSelector(state => state.LookupData);
  useEffect(() => {
    dispatch(GetLookupManagList());
  }, [dispatch]);

  useEffect(() => {
    if (Module?.length) {
      setModuleId(Module[0].id);
    }
  }, [Module]);

  useEffect(() => {
    const options = LookupData?.map(item => ({
      value: item.categoryValue,
      label: item.categoryName,
      moduleId: item.moduleId
    }))?.filter(f => f.moduleId === moduleId);
    setOptionSelect(options);
  }, [LookupData, moduleId]);

  const FilterByCategory = LookupData?.filter(f => f.categoryValue === categoryValue)[0];

  //________________________________
  const columns = [
    { title: t('LocalName'), key: 'Name2', className: 'w-25' },
    { title: t('GlobalName'), key: 'Name', className: 'w-25' },
    { title: t('Code'), key: 'Code', className: 'w-25' },
    { title: t('Status'), key: 'Status', className: 'w-25' },
    { title: t(''), key: 'action', className: 'text-end w-25' }
  ];

  const tableData = FilterByCategory?.lookupsList?.map(item => {
    let rowClass;

    return {
      Name2: item.meaning2,
      Name: item.meaning,
      Code: item.lookupCode,
      Status: item.enabledFlag ? (
        <span className='badge d-block rounded-0 pt-5px w-70px bg-success text-theme-900'>{t('isActive')}</span>
      ) : (
        <span className='badge d-block rounded-0 pt-5px w-70px bg-warning  '>{t('InActive')}</span>
      ),

      action: (
        <>
          {HasPermission('NtxEditgeneralsystemList') && (
            <div className='btn-group'>
              <button
                hidden={FilterByCategory?.isSystemLookup}
                type='button'
                className='btn btn-sm btn-outline-theme'
                data-bs-toggle='modal'
                data-bs-target='#UpdateLookup'
                onClick={() => setID(item.id)}
              >
                <i className='far fa-lg fa-fw me-2 fa-edit'></i>
                {t('Button.Edit')}
              </button>
            </div>
          )}
        </>
      ),

      rowClass // استخدم rowClass هنا
    };
  });
 
  return (
    <>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: 'Home',
            link: ':moduleHome'
          },
          {
            name: 'GeneralSystemLists',
            link: null
          }
        ]}
        PageName='GeneralSystemLists'
      />

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <div className='row'>
              <div className='col-xl-3  '>
                <div className='input-group flex-nowrap mb-2'>
                  <span className='input-group-text'>{t('Search')}</span>
                  <input
                    type='text'
                    autoComplete='off'
                    className='form-control '
                    onChange={e => {
                      setSearch(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>

              <div className='col-xl-4  '>
                <div className='input-group flex-nowrap mb-2'>
                  <span className='input-group-text'>{t('Application')}</span>
                  <Select
                    classNamePrefix='react-select'
                    className='w-100'
                    // isLoading={loading2}
                    isSearchable={true}
                    isClearable
                    options={
                      Module &&
                      Module?.map((item: any) => ({
                        value: item.id,
                        label: i18n.language === 'ar' ? item.name2 : item.name
                      }))
                    }
                    onChange={(option: any) => {
                      setCategoryValue('');
                      setModuleId(option === null ? null : option.value);
                      if (option === null) {
                        setCategoryValue(null);
                      }
                    }}
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  />
                </div>
              </div>

              <div className='col-xl-4  '>
                <div className='input-group flex-nowrap mb-2'>
                  <span className='input-group-text'>{t('Type')}</span>
                  <Select
                    isSearchable
                    options={optionSelect}
                    classNamePrefix='react-select'
                    className='w-100'
                    name='Select'
                    value={optionSelect?.find((f: any) => f.value === categoryValue) || null}
                    onChange={option => {
                      setCategoryValue(option?.value);
                      setCurrentPage(1);
                      setCategoryName(option?.label);
                    }}
                    placeholder='اخـتــر ... '
                    defaultValue={{
                      value: LookupData[0]?.categoryValue,
                      label: LookupData[0]?.categoryName
                    }}
                  />
                </div>
              </div>

              {HasPermission('NtxAddgeneralsystemList') && (
                <div className='col-xl-1 text-end'>
                  <button
                    hidden={FilterByCategory?.isSystemLookup}
                    type='button'
                    className='btn  w-100 btn-theme mb-2'
                    data-bs-toggle='modal'
                    data-bs-target='#AddLookup'
                  >
                    <i className='far fa-lg fa-fw   fa-plus'></i>
                  </button>
                </div>
              )}
            </div>

            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              // enableSearch
              // showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent id={'AddLookup'} title={t('Add')} size='sm'>
        {categoryValue && categoryName && (
          <AddLookup
            categoryName={categoryName}
            categoryValue={categoryValue}
            FilterByCategory={FilterByCategory?.lookupsList}
            moduleId={moduleId}
          />
        )}
      </ModalComponent>

      <ModalComponent id={'UpdateLookup'} title={t('Edit')} size='sm'>
        {ID && categoryValue && categoryName && (
          <UpdateLookup
            categoryName={categoryName}
            categoryValue={categoryValue}
            FilterByCategory={FilterByCategory?.lookupsList}
            ID={ID}
            moduleId={moduleId}
          />
        )}
      </ModalComponent>
    </>
  );
};

export default Lookup;
